import ApiUrls from "../helper/api-urls";
import ApiHelper from "../helper/api-helper";


const copyDocumentTemplateToregion = (
  fields,
  documentTemplateId,
  sourceRegionId
) => {
  var data = {
    sourceRegionId: sourceRegionId?.regionName?.id,
    documentTemplateId: documentTemplateId?.id,
    destinationRegionId: fields?.regionName?.id,
  };
  return ApiHelper.postRequest(ApiUrls.COPY_DOCUMENT_TEMPLATE_TO_REGION, data);
};


const insertAdmin = (fields, id) => {
  var data = {
    firstName: fields.firstName,
    lastName: fields.lastName,
    email: fields.email,
    mobile: fields.mobile,
  };
  return ApiHelper.postRequest(ApiUrls.ADMIN_USER_ADD, data);
};

const updateAdmin = (fields, id) => {
  var data = {
    id: id,
    firstName: fields.firstName,
    lastName: fields.lastName,
    email: fields.email,
    mobile: fields.mobile,
  };
  return ApiHelper.putRequest(ApiUrls.UPDATE_ADMIN_USER, data);
};

const getAdmins = () => {
  return ApiHelper.getRequest(ApiUrls.GET_ADMINS + "isActive=" + true);
};

const getAdminById = (id) => {
  return ApiHelper.getRequest(
    ApiUrls.GET_ADMIN_USER_BY_ID + id + "&isActive=" + true
  );
};
const copyStaffPlanTemplateToregion = (
  fields,
  documentTemplateId,
  sourceRegionId
) => {
  var data = {
    sourceRegionId: sourceRegionId?.regionName?.id,
    templateId: documentTemplateId?.id,
    destinationRegionId: fields?.regionName?.id,
  };
  return ApiHelper.postRequest(ApiUrls.COPY_STAFF_PLAN_TEMPLATE_TO_REGION, data);
};

const saveEobFiles = (data) => {
  return  ApiHelper.multipartPostRequest(ApiUrls.IMPORT_EOB_FILE, data);
};




export const AdminService = {
  copyDocumentTemplateToregion,
  getAdmins,
  getAdminById,
  updateAdmin,
  insertAdmin,
  copyStaffPlanTemplateToregion,
  saveEobFiles
};
